import type {TeamInvitationRole} from '@mattermost/types/teams';

export function isAnyTeamGuestRole(role: TeamInvitationRole) {
    return role === 'team_restricted_guest' || role === 'team_guest';
}
